import '../App.css';
import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";

function Home() {
return (
    <div className="App bgimg">
        <div id='home-grid'>
            <div id='home-grid-row-item-1'>
                <span id='home-italic-text'>A Film by Kevin Lundberg</span>
            </div>
            <div id='home-grid-row-item-2'>
                <div id='home-grid-row-item-2-container'>
                    <p id='home-header-text'>Art</p>
                    <p id='home-header-text'>Club</p>
                </div>
            </div>

            <div id='home-grid-row-item-3'>
                <span id='home-text'>Now streaming on Demand</span>
            </div>
            <div id='home-grid-row-item-4'>
                <div style={{display: 'flex', textAlign:'center',alignItems: 'center', paddingTop: '2rem' }}>
                    
                    <RouterLink target="_blank" rel="noreferrer" to="https://youtu.be/FbokR2mSVds">
                        <svg id='watch-now-play-button-svg' viewBox="0 0 24 24" >
                            <path d="M12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 Z M12,3.5 C7.30557963,3.5 3.5,7.30557963 3.5,12 C3.5,16.6944204 7.30557963,20.5 12,20.5 C16.6944204,20.5 20.5,16.6944204 20.5,12 C20.5,7.30557963 16.6944204,3.5 12,3.5 Z M9.0527864,8.5854102 C9.1625594,8.3658642 9.41205933,8.26236922 9.63961698,8.328815 L9.7236068,8.3618034 L16.1055728,11.5527864 C16.2023365,11.6011683 16.2807978,11.6796295 16.3291796,11.7763932 C16.4389526,11.9959392 16.3720486,12.2576361 16.1823574,12.3998148 L16.1055728,12.4472136 L9.7236068,15.6381966 C9.65417908,15.6729105 9.57762255,15.690983 9.5,15.690983 C9.25454011,15.690983 9.05039163,15.5141078 9.00805567,15.2808586 L9,15.190983 L9,8.80901699 C9,8.73139445 9.01807255,8.65483791 9.0527864,8.5854102 Z" id="playsvgpath"></path>
                        </svg>
                    </RouterLink>
                    <a style={{ color: 'white', paddingLeft: '.4rem', paddingRight: '2rem' }}>Trailer</a>

                    <RouterLink to="/Watch"><button id='watch-now-home-button' className='button-centered'>Watch Now</button></RouterLink>

                </div>
            </div>
        </div>
        <div id='home-grid-footer'>
            <div id='home-grid-footer-row-item-1'>
                <span id='home-grid-footer-row-item-1-text' >© 2025 Powered and secured by JL Studios</span>
            </div>
        </div>
    </div>
  );
}

export default Home;


